import { BaseUser, UserWithClients } from "../ClientAccessContext/types";

export interface Categories {
  [key: string]: PossibleLabelValue[];
}

export interface UserPreferences {
  applyFiltersOnEachChange: boolean;
}

export interface RawCategories {
  id: number;
  name: string;
  possibleLabelValues: PossibleLabelValue[];
  active?: boolean;
  category_label?: string;
  tenant_id?: string;
}

export interface PossibleLabelValue {
  id: number;
  value: string;
  active?: boolean;
}

export interface Topic {
  id: number;
  name: string;
}

export interface UserWithTopics extends BaseUser {
  clientId: number;
  role: UserRole;
  topics: Topic[];
}

export interface Filter {
  filterName: string;
  type: FilterType;
  filterItems: FilterItem[];
}

export enum FilterType {
  CATEGORY = "category",
  LANGUAGE = "language",
  CHECKED = "checked",
}

export interface FilterItem {
  propertie?: FilterType;
  filterLabel: string;
  value: string | boolean | number;
  checked: boolean;
  name?: string;
  possibleLabelValueId?: number;
}

// export interface User {
//     id: number,
//     clientId: number,
//     firstName: string,
//     lastName: string,
//     email: string,
//     role: UserRole,
//     adObjectId?: string
//     topics: Topic[]
// }

export enum UserRole {
  READER = "Reader",
  ADMIN = "Admin",
}

export enum LabelOutputType {
  CATEGORY = "Category label",
  RELEVANCY = "Relevancy score",
}

export enum LabelType {
  CATEGORICAL = "Categorical",
  NUMERIC = "Numeric",
}
